import { render } from "./DTColorRadio.vue?vue&type=template&id=0d999357&scoped=true"
import script from "./DTColorRadio.vue?vue&type=script&lang=js"
export * from "./DTColorRadio.vue?vue&type=script&lang=js"

import "./DTColorRadio.vue?vue&type=style&index=0&id=0d999357&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d999357"]])

export default __exports__